export default "__VITE_ASSET__c11c230e__"